// extracted by mini-css-extract-plugin
module.exports = {"selectionGroup":"_1dhW81GgDQ_calculator"};